export const HighlightComments = (data) => {

    const regex = /(?<=Comments:)([\s\S]*?)(?=<br\s*\/>\s*<br\s*\/>\s*<br\s*\/>\s*((\d{2}\s[A-Z]{3}\s\d{4}\s\d{2}:\d{2}:\d{2}\s(?:AM|PM))|\s*))/gm;

    const updatedContent = data.replace(regex, (match, group1, group2, group3, group4) => {
        return `<span class='highlighted-Comment'>${match.replace(/<br\s*\/?>/gi, '')}</span>`;
    });
    return updatedContent;
}
